import React, { createContext, useContext, useReducer, useEffect } from "react";

// Create Context
const WishlistContext = createContext();

// Reducer function
const wishlistReducer = (state, action) => {
  switch (action.type) {
    case "ADD_TO_WISHLIST":
      // Prevent adding duplicates
      if (state.some((item) => item._id === action.payload._id)) return state;
      return [...state, action.payload];

    case "REMOVE_FROM_WISHLIST":
      return state.filter((item) => item._id !== action.payload);

    default:
      return state;
  }
};

// Provider Component
export const WishlistProvider = ({ children }) => {
  // Get wishlist from localStorage on initial load
  const initialWishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

  const [wishlist, dispatch] = useReducer(wishlistReducer, initialWishlist);

  // Save wishlist to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem("wishlist", JSON.stringify(wishlist));
  }, [wishlist]);

  // Add item to wishlist
  const addToWishlist = (product) => {
    dispatch({ type: "ADD_TO_WISHLIST", payload: product });
  };

  // Remove item from wishlist
  const removeFromWishlist = (productId) => {
    dispatch({ type: "REMOVE_FROM_WISHLIST", payload: productId });
  };

  return (
    <WishlistContext.Provider value={{ wishlist, addToWishlist, removeFromWishlist }}>
      {children}
    </WishlistContext.Provider>
  );
};

// Custom Hook
export const useWishlist = () => useContext(WishlistContext);
